export default __webpack_public_path__ + "static/media/hand-mobile.80f7d74c.svg";